const checkLeftIntersection = function (el, screen, elCoordinates, widthOffset) {
    if (elCoordinates.left < 0) {
        el.style.left = `${Math.abs(elCoordinates.left) + widthOffset}px`;
    }
};

const checkBottomIntersection = function (el, screen, elCoordinates, heightOffset) {
    const offset = screen.height - elCoordinates.bottom;
    if (offset < 0) {
        el.style.top = `${heightOffset + offset}px`;
    }
};

export const fixBlockIntersection = function (el, elOffsets) {
    const offsets = {
        left: 0,
        bottom: 0,
    };
    Object.assign(offsets, elOffsets);
    if (el) {
        const elCoordinates = el.getBoundingClientRect();
        const screen = {
            height: window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight,
            width: window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth,

        };

        checkLeftIntersection(el, screen, elCoordinates, offsets.left);
        checkBottomIntersection(el, screen, elCoordinates, offsets.bottom);
    }
};
